import { reactive } from 'vue';
import errorMessages from './errorMessages';

export const errorMessageInterceptorStore = reactive({
  responseError: {
    code: 0,
    message: '',
    label: '',
  },
});

export const storeGetter = () => errorMessageInterceptorStore;

export const errorsInterceptor = (api) => {
  api.interceptors.response.use((config) => config, (error) => {
    if (error.response.status === 406) {
      if (error.response.data.data.expired) {
        localStorage.setItem('blockadeExpiredAt', error.response.data.data.expired);
      }
      errorMessageInterceptorStore.responseError.message = errorMessages['406'][`${error.response.data.data.message}`];
    } else if (error.response.status === 403) {
      errorMessageInterceptorStore.responseError.message = errorMessages['403'][`${error.response.data.message}`];
    }
    errorMessageInterceptorStore.responseError.code = error.response.status;
    errorMessageInterceptorStore.responseError.label = error.response.data.data.label;
    return Promise.reject(error);
  });
  return true;
};
